import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emsnseToEsm'
})
export class EsmnseToEsmPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value && value === 'ESMNSE') {
      return 'ESM';
    }
    return value;
  }
}
